var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#5FB16D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.98 11.6409C22.8026 10.1534 21.5367 9 20.0013 9C18.466 9 17.2 10.1534 17.0226 11.6409C14.5199 12.7755 12.7791 15.2955 12.7791 18.2222V23.2399L11.1086 26.5494C10.7729 27.2145 11.2563 28 12.0013 28H17.172C17.5838 29.1652 18.6951 30 20.0013 30C21.3075 30 22.4188 29.1652 22.8306 28H28.0013C28.7463 28 29.2297 27.2145 28.894 26.5494L27.2235 23.2399V18.2222C27.2235 15.2955 25.4827 12.7755 22.98 11.6409ZM25.3308 23.9286L26.3764 26H13.6262L14.6718 23.9286C14.7423 23.7888 14.7791 23.6345 14.7791 23.478V18.2222C14.7791 15.3381 17.1171 13 20.0013 13C22.8855 13 25.2235 15.3381 25.2235 18.2222V23.478C25.2235 23.6345 25.2603 23.7888 25.3308 23.9286Z",
    fill: "#5FB16D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOutline);
export default __webpack_public_path__ + "static/media/notificationOutline.78e6db98e2e4d2bd1cb8f8a5769240dc.svg";
export { ForwardRef as ReactComponent };